import React from 'react'

import { compose, defaultProps, withHandlers } from 'recompose'

import withPartnerProps from 'components/HOCs/WithPartnerProps'
import trackEvent from 'utils/analytics/trackEvent'
import { withFlowRouter } from 'utils/FlowProvider'
import { withOptimizely } from 'utils/Optimizely'
import withTieredRegistration, { WithTieredRegistrationProps } from 'utils/TieredRegistration'

import defaults from './defaults'
import withFields, { Fields } from './withFields'

type Props = {
  defaultFields?: object
  fields: object
}

type AddedProps = {
  trackClick: (event?: React.SyntheticEvent) => void
}

export type TrackClickProps = Props & AddedProps & WithTieredRegistrationProps

const enhance = compose<TrackClickProps, Props>(
  withOptimizely,
  withFlowRouter,
  withPartnerProps,
  withTieredRegistration,
  defaultProps({
    defaultFields: defaults('Button Tapped'),
    fields: {},
  }),
  withHandlers({
    trackClick: ({
      defaultFields,
      fields,
      flow,
      onClick,
      onPress,
      partner,
      trackOptimizely,
      tierPrice,
    }) => event => {
      if (onClick) {
        onClick(event)
      } else if (onPress) {
        onPress(event)
      }

      trackEvent('Button Tapped', {
        eventData: {
          ...defaultFields,
          ...fields,
          tierPrice,
        },
        partner,
        flow,
      })

      trackOptimizely(`${fields.object_name}.${defaultFields.event}`)
    },
  }),
)

export const withClickTrack = <TInner, TOuter>(customFields: Fields) =>
  compose<TInner, TOuter>(
    withFields(customFields),
    enhance,
    WrappedComponent => ({ trackClick, ...props }) => (
      <WrappedComponent {...props} onClick={trackClick} />
    ),
  )
